// @flow

"use strict";

/**
 * Inview関連オブジェクト
 */
export default class WidgetInview {
  constructor() {
    this.startEnable = false; // インビュー開始フラグ
    this.isDone = false;  // インビュー計測完了フラグ
    this.requestURL = ""; // インビューリクエストURL
    this.pointPixel = 0;  // インビュー計測ポイント
  }
}


// WEBPACK FOOTER //
// ./src/js/model/common/widget-inview.js